import { lazy } from 'react';

const Dashboard = lazy(() => import('@/modules/crm/pages/Dashboard'));
const Pipeline = lazy(() => import('@/modules/crm/pages/Pipeline'));
const Leads = lazy(() => import('@/modules/crm/pages/Leads'));
const Clientes = lazy(() => import('@/modules/crm/pages/Clientes'));
const Equipe = lazy(() => import('@/modules/crm/pages/Equipe'));
const Metas = lazy(() => import('@/modules/crm/pages/Metas'));
const Forecast = lazy(() => import('@/modules/crm/pages/Forecast'));
const ClosingPrediction = lazy(() => import('@/modules/crm/pages/ClosingPrediction'));
const RetentionDashboard = lazy(() => import('@/modules/crm/pages/RetentionDashboard'));
const Financeiro = lazy(() => import('@/modules/crm/pages/Financeiro'));
const WhatsApp = lazy(() => import('@/modules/crm/pages/WhatsApp'));
const Agendamentos = lazy(() => import('@/modules/crm/pages/Agendamentos'));
const PublicForms = lazy(() => import('@/modules/crm/pages/PublicForms'));
const Relatorios = lazy(() => import('@/modules/crm/pages/Relatorios'));
const NPSDashboard = lazy(() => import('@/modules/crm/pages/NPSSurvey'));
const NPSPublicSurvey = lazy(() => import('@/modules/crm/pages/NPSPublicSurvey'));
const EmailSequences = lazy(() => import('@/modules/crm/pages/EmailSequences'));

export interface ModuleRoute {
  path: string;
  component: React.LazyExoticComponent<any>;
  // Build CRM (crm.blacklegacy.com.br): apenas 'crm' é aceito.
  allowedTypes: Array<'crm'>;
}

export const crmRoutes: ModuleRoute[] = [
  { path: '/dashboard', component: Dashboard, allowedTypes: ['crm'] },
  { path: '/pipeline', component: Pipeline, allowedTypes: ['crm'] },
  { path: '/leads', component: Leads, allowedTypes: ['crm'] },
  { path: '/clientes', component: Clientes, allowedTypes: ['crm'] },
  { path: '/equipe', component: Equipe, allowedTypes: ['crm'] },
  { path: '/metas', component: Metas, allowedTypes: ['crm'] },
  { path: '/retencao', component: RetentionDashboard, allowedTypes: ['crm'] },
  { path: '/previsao', component: ClosingPrediction, allowedTypes: ['crm'] },
  { path: '/relatorios', component: Relatorios, allowedTypes: ['crm'] },
  { path: '/agendamentos', component: Agendamentos, allowedTypes: ['crm'] },
  { path: '/financeiro', component: Financeiro, allowedTypes: ['crm'] },
  { path: '/whatsapp', component: WhatsApp, allowedTypes: ['crm'] },
  { path: '/formularios', component: PublicForms, allowedTypes: ['crm'] },
  { path: '/nps', component: NPSDashboard, allowedTypes: ['crm'] },
  { path: '/forecast', component: Forecast, allowedTypes: ['crm'] },
  { path: '/email-sequences', component: EmailSequences, allowedTypes: ['crm'] },
];

export { NPSPublicSurvey };
